import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { adminPath } from "@/lib/adminBase";
import { Eye, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  if (!user?.is_impersonation) return null;
  const end = async () => {
    try {
      const { data } = await api.post("/auth/impersonation/end");
      setUser(data.user);
      toast.success("Returned to your admin session");
      navigate(adminPath("/users"));
    } catch (e) {
      toast.error("Admin session expired — please sign in again");
      navigate(adminPath("/login"));
    }
  };
  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-400 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 text-sm shadow-md" data-testid="impersonation-banner">
      <Eye className="w-4 h-4 shrink-0" />
      <span className="font-semibold">Audit view: you are browsing as <b>{user.name || user.email}</b> ({user.role}) · started by {user.actor_email}</span>
      <button onClick={end} className="ml-2 bg-amber-900 text-amber-50 px-3 py-1 rounded-full text-xs font-bold hover:bg-amber-800 flex items-center gap-1 transition-colors" data-testid="impersonation-end">
        <LogOut className="w-3 h-3" /> Return to admin
      </button>
    </div>
  );
}
